import React from 'react';
import { Search, Edit, Trash2 } from 'lucide-react';

const PatientList = ({
  patients,
  searchTerm,
  setSearchTerm,
  isLoading,
  handleEditPatient,
  handleDeletePatient,
}) => {
  const iconProps = { className: 'h-4 w-4' };

  return (
    <div className="bg-secondary-main mt-5 rounded shadow">
      <div className="flex flex-col justify-between gap-4 p-4 md:flex-row">
        <div>
          <h2 className="text-lg font-semibold">Pacientes ({patients.length})</h2>
          <p className="text-sm text-gray-400">Lista de pacientes registrados</p>
        </div>
        <div className="relative w-full md:w-64">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            className="focus:ring-primary-main w-full rounded border border-gray-300 bg-black py-2 pl-10 pr-3 text-white focus:outline-none focus:ring-2"
            placeholder="Buscar por nombre, apellido o ID..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 overflow-y-auto p-4">
        {isLoading ? (
          <p className="py-8 text-center text-gray-400">Cargando pacientes...</p>
        ) : patients.length > 0 ? (
          patients.map(patient => (
            <div
              key={patient._id}
              className="bg-secondary-dark border-primary-active gap-4 rounded border p-4 shadow max-sm:flex-col max-sm:gap-3 sm:flex sm:items-center sm:justify-between"
            >
              <div className="min-w-[150px] flex-1">
                <h3 className="text-md font-semibold">
                  {patient.firstName} {patient.lastName}
                </h3>
                <p className="text-sm text-gray-300">ID: **{patient.patientId}**</p>
              </div>

              <div className="flex flex-col items-start sm:flex-row sm:items-center sm:gap-4">
                <span className={`rounded bg-blue-200 px-2 py-1 text-xs uppercase text-blue-800`}>
                  {patient.gender}
                </span>
                <p className="text-xs text-gray-400">
                  Nacimiento: {patient.dateOfBirth?.split('T')[0]}
                </p>
                {patient.phoneNumber && (
                  <p className="text-xs text-gray-400">Tel: {patient.phoneNumber}</p>
                )}

                <div className="mt-2 flex gap-2 sm:mt-0">
                  <button
                    onClick={() => handleEditPatient(patient)}
                    className="p-1 text-blue-300 hover:text-blue-600"
                    title="Editar paciente"
                  >
                    <Edit {...iconProps} />
                  </button>
                  <button
                    onClick={() => handleDeletePatient(patient._id)}
                    className="p-1 text-red-300 hover:text-red-800"
                    title="Eliminar paciente"
                  >
                    <Trash2 {...iconProps} />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="py-8 text-center text-gray-400">No se encontraron pacientes registrados.</p>
        )}
      </div>
    </div>
  );
};

export default PatientList;
